import { render, staticRenderFns } from "./SavedCard.vue?vue&type=template&id=937edb4e"
import script from "./SavedCard.vue?vue&type=script&lang=js"
export * from "./SavedCard.vue?vue&type=script&lang=js"
import style0 from "./SavedCard.vue?vue&type=style&index=0&id=937edb4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports